import ConfirmationDialog from 'shared/ui/dialog/confirmation-dialog';
import * as m from '@paraglide/messages';
export const GitConfirm = ({
  open,
  setOpen,
  onConfirm
}) => {
  return <ConfirmationDialog open={open} onOpen={setOpen} onConfirm={onConfirm} title="GIT" description={m.create_dialog_step_gitDialog_desc()} cancelText={m.btn_cancel()} confirmText={m.create_dialog_step_gitDialog_confirm()} data-sentry-element="ConfirmationDialog" data-sentry-component="GitConfirm" data-sentry-source-file="git-confirm.tsx" />;
};